import { Inline, Text, textColors } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { generateDurationText } from '../../utils/calendarDateUtils';

interface CalendarFooterProps {
  departureDate?: Date | string | null;
  returnDate?: Date | string | null;
}

const CalendarFooter = ({ departureDate, returnDate }: CalendarFooterProps) => {
  const { t } = useTranslation();
  return (
    <Inline align="center">
      <Text as="p" color={textColors.PRIMARY}>
        {generateDurationText(
          departureDate,
          returnDate,
          t('Searchform.Calendar.DaysLeft.Singular'),
          t('Searchform.Calendar.DaysLeft.Plural'),
        )}
      </Text>
    </Inline>
  );
};

export default CalendarFooter;
